import { render, staticRenderFns } from "./BucketActions.vue?vue&type=template&id=af445d22&scoped=true&"
import script from "./BucketActions.vue?vue&type=script&lang=js&"
export * from "./BucketActions.vue?vue&type=script&lang=js&"
import style0 from "./BucketActions.vue?vue&type=style&index=0&id=af445d22&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af445d22",
  null
  
)

export default component.exports